function createJsonProductionOsRequest(contract){
  
  let OsRequestContract =  {
    osNumber: contract.osNumber,
    statusOS: contract.statusOS,
    observation: contract.observation,
    source: contract.source,
    typeOS: contract.typeOS.value == null ? contract.typeOS : contract.typeOS.value,
    writeOffCode: contract.writeOffCode.value == null ? contract.writeOffCode : contract.writeOffCode.value
  }
  if (OsRequestContract.observation === null || OsRequestContract.observation === "") {
    delete OsRequestContract.observation;
  }

  return OsRequestContract;
  
}


export default createJsonProductionOsRequest;